import Model from "~/models/_Model";
import dayjs from "dayjs";
import User from "../User";
import Student from "./Student";

export default class Note extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courserecommendations";
  }

  // Set the resource route of the model
  resource() {
    return "notes";
  }

  relations() {
    return {
      author: User,
      student: Student,
    };
  }

  // Computed Attributes
  get display_change_date_time() {
    return dayjs(this.change_date_time).format("MM/DD/YYYY h:mm:ss A");
  }

  get display_author() {
    return this.author ? this.author.display_name : this.change_uid;
  }
}
